import React, { FC } from "react";
import PifBreadcrumbs from "./PifBreadcrumbs";
import "./PifPageBand.scss";

interface PifPageBandProps {
  /** The h1, in the slot the shared page-detail band gives the page title. */
  title: string;
  /**
   * Terminal crumb — where the user is right now. Omit it on the list page itself, so
   * "Post Interview List" ends the trail instead of linking to where you already are.
   */
  current?: string;
  /** Passed straight through to PifBreadcrumbs — see its `showListCrumb`. */
  showListCrumb?: boolean;
}

/**
 * Page header for the PostIF screens.
 *
 * App.tsx sets `hidePageDetail` for every /hiring/postif route, so these screens have to
 * bring their own band. This is it, and PifPageBand.scss copies the shared band's every value
 * from layouts/page-detail/PageDetail.scss, so the two read identically. Shared by the list page
 * and the form shell rather than written out in each, so they can't drift apart.
 */
const PifPageBand: FC<PifPageBandProps> = ({ title, current, showListCrumb = true }) => (
  <header className="pif-band">
    <div className="pif-band__content">
      <h1 className="pif-band__title">{title}</h1>
      <div className="pif-band__breadcrumbs">
        <PifBreadcrumbs current={current} tone="onDark" showListCrumb={showListCrumb} />
      </div>
    </div>
  </header>
);

export default PifPageBand;
